<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Error Report</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Search Filter -->
    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label>Submitted Date from</label>
          <input type="date" class="form-control" v-model="submittedDateFrom" />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Submitted Date to</label>
          <input type="date" class="form-control" v-model="submittedDateTo" />
        </div>
      </div>
      <div class="col-md-1">
        <button class="btn btn-primary filter-btn" @click="search">View</button>
      </div>
    </div>
    <!-- /Search Filter -->

    <!-- Pagination -->
    <div class="row mt-3">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="no-col">S/N</th>
                <th class="date-col">
                  <button class="btn p-0" @click="setSortBy('submittedDate')">
                    Submitted Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'submittedDate'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'submittedDate_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="name-col">
                  <button class="btn p-0" @click="setSortBy('submittedBy')">
                    Submitted By
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'submittedBy'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'submittedBy_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="error-col">
                  <button class="btn p-0" @click="setSortBy('errorMessage')">
                    Error Message
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'errorMessage'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'errorMessage_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="action-col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in errors" :key="item.Id">
                <td class="no-col">
                  {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    i +
                    1
                  }}
                </td>
                <td class="date-col">{{ item.SubmittedDateDisplay }}</td>
                <td class="name-col">{{ item.SubmittedBy }}</td>
                <td class="error-col">{{ item.ErrorMessage }}</td>
                <td class="action-col">
                  <button
                    @click="view(item.Id)"
                    class="btn btn-sm btn-link p-0"
                  >
                    <i class="far fa-file-alt mr-1"></i>View
                  </button>
                </td>
              </tr>
              <tr v-if="errors && !errors.length">
                <td colspan="5" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="errors && errors.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          errors.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->

    <!-- View Error Detail Modal -->
    <div class="modal custom-modal fade" id="viewErrorDetail" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header pt-4">
            <h5 class="modal-title">Class Booking Detail</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pt-3" v-if="errorDetail">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Submitted Date</b></label>
                <div>{{ errorDetail.SubmittedDateDisplay }}</div>
              </div>
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Submitted By</b></label>
                <div>{{ errorDetail.SubmittedBy }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>User Type</b></label>
                <div>{{ errorDetail.UserType }}</div>
              </div>
              <div class="form-group col-md-6">
                <label class="mb-0"><b>School Name</b></label>
                <div>{{ errorDetail.SchoolName }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Student Name</b></label>
                <div>{{ errorDetail.StudentName }}</div>
              </div>
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Student Email</b></label>
                <div>{{ errorDetail.StudentEmail }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Class Subject</b></label>
                <div>{{ errorDetail.SubjectName }}</div>
              </div>
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Subject Level</b></label>
                <div>{{ errorDetail.SubjectLevelName }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Duration</b></label>
                <div>{{ errorDetail.Duration }}</div>
              </div>
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Make-up Class</b></label>
                <div>{{ errorDetail.MakeupClass }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6" v-if="errorDetail.Location">
                <label class="mb-0"><b>Location</b></label>
                <div>{{ errorDetail.Location }}</div>
              </div>
              <div
                class="form-group col-md-6"
                v-if="errorDetail.LocationSchoolAddress"
              >
                <label class="mb-0"><b>School Address</b></label>
                <div>{{ errorDetail.LocationSchoolAddress }}</div>
              </div>
            </div>
            <div class="form-row" v-if="errorDetail.PaymentOption">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Payment Option</b></label>
                <div>{{ errorDetail.PaymentOption }}</div>
              </div>
              <div class="form-group col-md-6" v-if="errorDetail.PaymentProof">
                <label class="mb-0"><b>Payment File</b></label>
                <div>
                  <button
                    type="button"
                    class="btn btn-link px-0"
                    @click="
                      downloadPaymentFile(
                        errorDetail.PaymentProof,
                        errorDetail.PaymentProofFileName
                      )
                    "
                  >
                    {{ errorDetail.PaymentProofFileName }}
                  </button>
                </div>
              </div>
            </div>
            <div class="form-row mt-1">
              <div class="form-group col-md-12">
                <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
                  <table class="table table-bordered">
                    <thead class="thead-light">
                      <tr>
                        <th class="no-col">#</th>
                        <th>Booking Date</th>
                        <th>Booking Time</th>
                        <th v-if="errorDetail.MakeupClass == 'No'">
                          Fee ({{ errorDetail.Currency }})
                        </th>
                        <th>Instructor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, i) in errorDetail.ErrorBookings"
                        :key="i"
                      >
                        <td class="no-col">{{ i + 1 }}</td>
                        <td>{{ item.BookingDateDisplay }}</td>
                        <td>
                          {{ item.BookingTime }} ({{ item.TimezoneName }})
                        </td>
                        <td
                          v-if="errorDetail.MakeupClass == 'No'"
                          class="text-right"
                        >
                          {{ item.FeeAmountPaid | formatFee }}
                        </td>
                        <td>{{ item.InstructorName }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="submit-section mt-0">
              <button class="btn btn-primary submit-btn" @click="close">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /View Error Detail Modal -->
  </div>
</template>


<script>
import API from "../../http-common.js";
import config from "../../config.js";
import $ from "jquery";
export default {
  filters: {
    formatFee(val) {
      if (!val) return "";
      const options = { style: "decimal", minimumFractionDigits: 2 };
      return val.toLocaleString("en-US", options);
    },
  },
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      submittedDateFrom: "",
      submittedDateTo: "",
      errors: [],
      errorDetail: null,
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.Token;
    },
  },
  watch: {
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getSchoolList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    search() {
      //set the state from filter
      this.$store.state.errorReportFilter.submittedDateFrom =
        this.submittedDateFrom;
      this.$store.state.errorReportFilter.submittedDateTo =
        this.submittedDateTo;
      this.getErrorList();
    },
    getErrorList() {
      let param = {
        Token: this.token,
        CurrentPage: this.paging.CurrentPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        SubmittedDateFrom: this.submittedDateFrom,
        SubmittedDateTo: this.submittedDateTo,
      };
      this.$store.state.isLoading = true;
      API.mainAdmin
        .getErrorList(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.errors = response.data.data;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    view(id) {
      let param = {
        Token: this.token,
        Id: id,
      };
      API.mainAdmin
        .getErrorDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.errorDetail = response.data.data;
            $("#viewErrorDetail").modal("show");
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    downloadPaymentFile(paymentProof, paymentFileName) {
      const base64String = paymentProof.split(",")[1];
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = paymentFileName;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    close() {
      $("#viewErrorDetail").modal("hide");
    },
    //for pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getErrorList();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getErrorList();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getErrorList();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getErrorList();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getErrorList();
    },
    setSortBy(payload) {
      switch (payload) {
        case "submittedDate":
          if (this.paging.SortBy === "submittedDate") {
            this.paging.SortBy = "submittedDate_desc";
          } else if (this.paging.SortBy === "submittedDate_desc") {
            this.paging.SortBy = "submittedDate";
          } else {
            this.paging.SortBy = "submittedDate";
          }
          break;
        case "submittedBy":
          if (this.paging.SortBy === "submittedBy") {
            this.paging.SortBy = "submittedBy_desc";
          } else if (this.paging.SortBy === "submittedBy_desc") {
            this.paging.SortBy = "submittedBy";
          } else {
            this.paging.SortBy = "submittedBy";
          }
          break;
        case "errorMessage":
          if (this.paging.SortBy === "errorMessage") {
            this.paging.SortBy = "errorMessage_desc";
          } else if (this.paging.SortBy === "errorMessage_desc") {
            this.paging.SortBy = "errorMessage";
          } else {
            this.paging.SortBy = "errorMessage";
          }
          break;
      }
      this.getErrorList();
    },
  },
  created() {
    //populate the filter from state
    let errorReportFilter = this.$store.state.errorReportFilter;
    this.submittedDateFrom = errorReportFilter.submittedDateFrom;
    this.submittedDateTo = errorReportFilter.submittedDateTo;
    this.getErrorList();
  },
};
</script>

<style scoped>
.name-col {
  width: 300px;
}
.action-col {
  width: 100px;
}
.error-col {
  word-wrap: break-word;
  white-space: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/MainAdmin/ErrorReport.vue